import sdk from '@/sdk';
import {loadScript} from '@/utils';

const kuEnv = process.env.REACT_APP_ENVIRONMENT;

// flowSDK环境数据
const flowSDKPath = '/workflow/api/engine-pre/js-rcv/flowSDK.js?sceneId=knowledge';
const flowSDKEnvObj = {
    dev: ['dev', `https://workflow-dev.dev.weiyun.baidu.com${flowSDKPath}`],
    test: ['dev', `https://nginx-test.dev.weiyun.baidu.com${flowSDKPath}`],
    preonline: ['preonline', `https://workflow-preonline.dev.weiyun.baidu.com${flowSDKPath}`],
    gray: ['gray', `https://developer-gray.baidu-int.com${flowSDKPath}`],
    online: ['online', `https://developer.baidu-int.com${flowSDKPath}`],
};

// 知识库到SDK的环境映射
const envMap = {
    local: 'test',
    rd: 'test',
    qa: 'preonline',
    gray: 'gray',
    online: 'online',
};

// @ts-ignore 忽略类型检查
const [flowSDKEnv, flowSDKUrl] = flowSDKEnvObj[envMap[kuEnv]] || flowSDKEnvObj.online;

/**
 * 获取目标的token
 *
 * @param target 目标
 * @param source 调用来源 'init' | 'sdk'
 * @returns 返回目标的token
 */
function getToken(target: string = 'flowSDK', source: string = 'init') {
    return sdk.as.getUgateToken(target, source);
}

/**
 * 加载 FlowSDK
 *
 * @returns {Promise<any>} FlowSDK实例
 */
const loadFlowSDK = (() => {
    if (window.isTocPage) {
        return;
    }

    let loadingFlowSDKPromise: any = null;
    return async () => {
        if ((window as any).isSdkPage) {
            return Promise.reject();
        }
        if (loadingFlowSDKPromise) {
            return loadingFlowSDKPromise;
        }

        loadingFlowSDKPromise = (async () => {
            const token = await getToken('flowSDK', 'init');
            return loadScript(`${flowSDKUrl}&token=${token}`).then(() => {
                const createFlowSDK = (window as any).createFlowSDK;
                const flowSDK = createFlowSDK();
                return flowSDK;
            });
        })();

        return loadingFlowSDKPromise;
    };
})();

export {loadFlowSDK, flowSDKEnv, getToken};
